// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_fab07e42","icon":"_1d0c293a","vipText":"_1f6078e3"};